import Cookies from 'universal-cookie'
import { PULSE_DATA_COOKIE } from 'constants'

export const extractPulseId = (value) => {
  if (typeof value === 'string') {
    return decodeURIComponent(value).split(',')[0]
  }
  return 'no_pulse_id'
}

export const getPulseCookie = (ctx) => {
  try {
    return ctx ? ctx.cookies.get(PULSE_DATA_COOKIE) : new Cookies().get(PULSE_DATA_COOKIE)
  } catch (e) {
    return undefined
  }
}

export const getPulseEnvId = (ctx) => {
  if (ctx) {
    // server-side
    return extractPulseId(getPulseCookie(ctx))
  }
  // client-side
  return extractPulseId(getPulseCookie())
}

/*
 * "await" the pulse tracking since it lacks async support
 * 500ms seem like a sweetspot
 * e.g. of use-case: track before redirect
 */
export const awaitPulseTracking = (tracking, callback) => {
  if (!tracking || !callback) {
    return console.warn('You need to provide a tracking event and callback.')
  }

  tracking()

  setTimeout(() => {
    callback()
  }, 500)
}
